import { Form, message } from "antd";
import { ColumnsType } from "antd/es/table";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CREATE_GROUP_MENU, LIST_PRODUCT_UNGROUPED } from "../../commons/constants/api-urls";
import useFetchList from "../../commons/hooks/useFetchList";
import useTable from "../../commons/hooks/useTable";
import defaultAxios from "../../commons/utils/axios";
import { AppContext } from "../../contexts/AppContext";
import GroupMenuLayout from "./GroupMenuLayout";
import styles from "./styles.module.scss";
import useGroupMenu from "./useGroupMenu";
import { routerNavigation, routers } from "../../commons/constants/routers";
import CustomModal from "../../commons/components/CustomModal/CustomModal";

const CreateNewGroupMenu = () => {
  const navigate = useNavigate();
  const { storeId } = useParams<{ storeId: string }>();
  const { currentStore, findAndSetStore } = useContext(AppContext);
  const [keyword, setKeyword] = useState("");
  const [form] = Form.useForm();
  const {
    getBody,
    getListProduct,
    dataSrc,
    handleMarkProductReview,
    dataSelected,

    openModal,
    setOpenModal,
    isAdd,
  } = useGroupMenu();
  const { onShowSizeChange, page, perPage, setPage } = useTable();
  const { data, total, loading, setLoading } = useFetchList<ProductItem>(
    currentStore ? LIST_PRODUCT_UNGROUPED(currentStore.id) : "",
    {
      perPage,
      page,
      search: keyword.trim(),
      paginationMetadataStyle: "body",
    }
  );

  const columns: ColumnsType<ProductMenu> = [
    {
      title: "Product Name",
      dataIndex: "name",
      render: (text, record, index) => {
        return text;
      },
    },
    {
      title: "Product ID ",
      dataIndex: "id",
      render: (text, record, index) => {
        return text;
      },
    },
    {
      title: "Action ",
      render: (text, record, index) => {
        return (
          <div className={styles.actions}>
            <div className={styles.edit}>
              <div
                className={`${styles.preview} ${record.isGrouped && styles.true}`}
                onClick={() => handleMarkProductReview(record.id, record.isGrouped)}
              >
                {record.isGrouped ? "Remove" : "Add To Group"}
              </div>
            </div>
          </div>
        );
      },
    },
  ];

  async function onFinish(values: { "group-name": string }) {
    setLoading(true);
    try {
      const body = getBody(values);

      await defaultAxios.post(CREATE_GROUP_MENU(currentStore.id), body);

      navigate(routerNavigation.STORES.GROUP_MENU(storeId!));
      message.success("Create group success");
    } catch (error) {
      console.log(error);
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (data) {
      getListProduct(data);
    }
  }, [data, dataSelected]);

  useEffect(() => {
    if (!storeId) return;
    findAndSetStore(storeId);
  }, [storeId]);

  return (
    <div>
      <Form form={form} name="form-group" onFinish={onFinish}>
        <GroupMenuLayout
          isEdit={false}
          columns={columns}
          dataSrc={dataSrc}
          loading={loading}
          onShowSizeChange={onShowSizeChange}
          page={page}
          perPage={perPage}
          selectedProductId={dataSelected.length}
          setKeyword={setKeyword}
          setPage={setPage}
          total={total}
        />
      </Form>
      <CustomModal
        onOk={() => setOpenModal(false)}
        onCancel={() => setOpenModal(false)}
        open={openModal}
        children={
          <p style={{ color: "white", textAlign: "center", fontSize: "22px" }}>
            {" "}
            {isAdd ? "Add Product Success" : "Remove Product Success"}
          </p>
        }
      ></CustomModal>
    </div>
  );
};

export default CreateNewGroupMenu;
